import { Component, Input, OnChanges } from '@angular/core';
import { Order } from 'src/interfaces/order.interface';
import { MobileService } from 'src/services/mobile.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HandoffType } from '../../../../../interfaces/handoff-type.enum';
import { Select } from '@ngxs/store';
import { AppStateModel } from '../../../../../store/state/app.state';
import { TextField } from '../../../../../vendors/directus/interfaces/text-field.interface';
import { GlobalStateModel } from 'src/store/state.model';

// Layout Strategy Interface
interface NavOrderTypeLayoutStrategy {
  getContainerClasses(): string;
  getHeaderClasses(): string;
  getIconClasses(): string;
}

// Default Layout Strategy
class DefaultNavOrderTypeLayoutStrategy implements NavOrderTypeLayoutStrategy {
  getContainerClasses(): string {
    return 'text-center';
  }

  getHeaderClasses(): string {
    return 'text-uppercase fw-bold fs-12 d-flex justify-content-center w-100';
  }

  getIconClasses(): string {
    return '';
  }
}

// Branded Layout Strategy
class BrandedNavOrderTypeLayoutStrategy implements NavOrderTypeLayoutStrategy {
  getContainerClasses(): string {
    return 'branded-layout';
  }

  getHeaderClasses(): string {
    return 'text-uppercase fw-bold font-size-xsmall d-grid place-items-center';
  }

  getIconClasses(): string {
    return 'bi bi-geo-alt-fill d-flex align-items-center pe-1 font-size-subheading-1';
  }
}

// Layout Factory
class NavOrderTypeLayoutFactory {
  static createStrategy(layoutType: string): NavOrderTypeLayoutStrategy {
    switch (layoutType) {
      case 'branded':
        return new BrandedNavOrderTypeLayoutStrategy();
      case 'default':
      default:
        return new DefaultNavOrderTypeLayoutStrategy();
    }
  }
}

@Component({
  selector: 'app-mobile-nav-order-type',
  templateUrl: './nav-order-type.component.html',
  styleUrls: ['./nav-order-type.component.scss'],
})
export class MobileNavOrderTypeComponent implements OnChanges {
  @Select(state => state.app) app$: Observable<AppStateModel>;
  @Select(state => state.app.textField) textField$: Observable<TextField>;
  @Select((state: GlobalStateModel) => state.order.brandHandoffs) brandHandoffs$: Observable<{ handoff: HandoffType; label: string }[]>;
  @Input() order: Order;
  @Input() layout: string;
  handoffs = HandoffType;

  // Layout strategy
  currentLayoutStrategy: NavOrderTypeLayoutStrategy;

  filterTags: string[];
  constructor(
    public mobile: MobileService,
    public router: Router
  ) {
    // Initialize with default strategy
    this.currentLayoutStrategy = NavOrderTypeLayoutFactory.createStrategy('default');
    this.textField$.subscribe(textFields => {
      if (textFields) {
        this.filterTags = textFields.filter_brand_name_from_location;
      }
    });
  }

  ngOnChanges(): void {
    // Update strategy when layout changes
    if (this.layout) {
      this.currentLayoutStrategy = NavOrderTypeLayoutFactory.createStrategy(this.layout);
    }
  }

  // Helper methods for template
  getContainerClasses(): string {
    return this.currentLayoutStrategy.getContainerClasses();
  }

  getHeaderClasses(): string {
    return this.currentLayoutStrategy.getHeaderClasses();
  }

  getIconClasses(): string {
    return this.currentLayoutStrategy.getIconClasses();
  }
}
